import { useStore } from "@/store";
const store = useStore();
import { GeneralActionTypes } from "@/store/modules/general/action-types";
let tempData: string | any[] = [];
import { Roles } from "../enums/Roles";

const company = store.getters.company;
let path = `company/${company.companyGuid}/sites`;
const user = store.getters.loggedInUser;
const site = store.getters.site;
const group = store.getters.group;
if(user.role === Roles.AGMSAdmin) {
  path = `company/`
}else if(user.role === Roles.PartnerAdmin) {
  path = `company/`
}else if(user.role === Roles.CompanyAdmin) {
  path = `company/${company.companyGuid}/sites`
}else if(user.role === Roles.SiteAdmin) {
  path = `company/${company.companyGuid}/sites/${site.key}/groups`
}else if(user.role === Roles.GroupAdmin) {
  path = `company/${company.companyGuid}/sites/${site.key}/groups/${group.key}/computers`
}

const data = {
  filter: {
    title: "groupListfilter",
    pageName: "groupListfilter",
    genre: "assetPageFilter",
    hideFilter: true,
    filters: [
    ],
  },
  header: {
    navigation: [
      {
        title: "endpoints",
        icon: "drak_computer",
        url: "computers/all",
      },
      {
        title: "browseassets",
        active: true,
        icon: "breadcrumb",
        url: path,
      },
      {
        title: "usersbycomputer",
        icon: "group",
        url: "users-by-computers",
      },
    ],
    buttonPosition: "pr-4 justify-content-between",
    buttons: [],
  },
  component: {
    type: "ag-table",
    options: {
      columns: [
        {
          label: "groupname",
          field: "companySiteOrGroupName",
          sortable: true,
          jsSort: true,
          components: [
            {
              component: "rowRouter",
              key: "sitename",
              route: function (row: any) {
                const url = `/endpoints/company/${row.info.companyId}/sites/${row.info.siteId}/groups/${row.info.groupId}/computers`;
                return url;
              },
              displayField: "companySiteOrGroupName",
            },
          ],
        },
        {
          label: "computerCount",
          field: "computerCount",
          format: 'number',
          sortable: true,
          jsSort: true,
        },
        {
          label: "malicioushashes",
          field: "maliciousHashes",
          format: 'number',
          sortable: true,
          jsSort: true,
        },
        {
          label: "eventcount",
          field: "eventCount",
          format: 'number',
          sortable: true,
          jsSort: true,
        },
      ],
      allRows: [],
      rows: [],
      total: 0,
      sortable: {
        order: "name",
        sort: "asc",
      },
      page: 1,
      pageSize: 5,
      isLoading: true,
      fetchTable: async (options: any) => {
        if (tempData.length === 0) {
          tempData = options.allRows;
        }
        const page = options.page;
        const pageSize = options.pageSize;
        const data = tempData.slice((page - 1) * pageSize, page * pageSize);

        (options || {}).rows = data;
      },
    },
  },
};

export default data;
